import React, { CSSProperties, ReactNode } from 'react';
import TextLink from '../../../../ui/TextLink/TextLink';

interface MarketingLinkProps {
  children: ReactNode;
}

export const templateLinkContext = (
  href: string,
  linkStyle: CSSProperties | undefined,
  linkHoverStyle: CSSProperties | undefined,
) => {
  const MarketingLink = ({ children }: MarketingLinkProps) => (
    <TextLink
      key={href}
      linkStyle={{ sDefault: linkStyle, sHover: linkHoverStyle }}
      href={href ?? ''}
    >
      {children}
    </TextLink>
  );

  return MarketingLink;
};
